import {WIDTH} from 'components/pianoroll/constants.js';
const Y_PADDING = 3;

export const getYForParameter = (step, parameter, height) => {
    return getYPositionFromValue(
        parameter.automation.getValueAtStep(step),
        height,
        parameter.min,
        parameter.max);
    };

export function getXPositionFromStep(step,  xScale) {
    return xScale * WIDTH * step / 2;
}

export function getYPositionFromValue(value, height, min=0, max=1) {
    if (value === undefined || value === null) {
        return 0;
    }
    if (value.toFrequency) {
        value = value.toFrequency();
    }
    value = (value - min) / (max - min);
    if (min===0) {
        value = Math.sqrt(value);
    }
    return Math.max(5, height - value * height - Y_PADDING);
}

export function getStepFromXPosition(x, xScale) {
    return 2 * x / (WIDTH * xScale);
}

export function getValueFromYPosition(y, height, min=0, max=1) {
    y += Y_PADDING;
    let value = (height - y) / height;
    if (min===0) {
        value = Math.pow(value, 2);
    }
    return Math.max(min, min + value * (max - min));
}



